<template>
  <el-table-column
    prop="suffix"
    sortable="custom"
    label="Utótag"
    show-overflow-tooltip
    min-width="160"
    fixed
  >
    <template slot-scope="scope">
      {{ scope.row.suffix }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'suffix',
  };
</script>
